import { Component, Output, EventEmitter, Input, ViewChild, ElementRef, ChangeDetectorRef, AfterViewInit } from '@angular/core';
@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})

export class ButtonComponent implements AfterViewInit{  
  @Output() clickButton = new EventEmitter();
  @Input() isRounded: boolean;
  @Input() feasibilityBlocked: boolean;
  @Input() isEnabled: boolean;
  @Input() isUpload: boolean = false;
  @Input() isWaitingBuildings: boolean;
  @Input() selectedPoints: any;
  @Input() selectedFile: any;
  @ViewChild('buttonTextRef') buttonRef: ElementRef;

  constructor(private cd: ChangeDetectorRef) {}

  ngAfterViewInit() {this.cd.detectChanges();}

  get isDisabled() {    
    if (this.isUpload) {    
      return !this.isEnabled;
    } else {
      if (!this.isEnabled || this.feasibilityBlocked || this.isWaitingBuildings) {          
        return true;
      } else {       
        return false;
      }
    }
  }

  get isBtnFeasibility(): boolean {
    if (!this.isRounded) {
      const text = this.buttonRef?.nativeElement.textContent;
      return text?.trim().toLocaleLowerCase() === 'check feasibility' && text !== undefined;
    }
  }
}
